
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox, Avatar, Button, ListItemText, Table, Tooltip, MenuItem, IconButton } from "@mui/material";
import CustomPopover, {usePopover} from '../../../components/custom-popover/index.js';
import Iconify from "../../../components/iconify/iconify.js";
import { ConfirmDialog } from '../../../components/custom-dialog/index.js';
import { useBoolean } from '../../../hooks/use-boolean.js';
import { parseISO, format } from 'date-fns';
import {courseMode} from '../../../util/course.js';
import {fDate} from '../../../util/formatTime.js';
import { staticForm1, staticForm2 } from 'src/util/formCategory.js';
import Label from '../../../components/label/label.js';

export default function AuditingTableRow({
    row, selected, tableHead, onDeleteRow, onEditRow, onViewRow, onSelectRow, formId, onArchive, onComplete, onCancelled, revertInProgress
}){

    const { section, status } = row;
    const popover = usePopover();
    const confirm = useBoolean();
    const confirmArchive = useBoolean();
    const confirmComplete = useBoolean();
    const confirmCancelled = useBoolean();
    const isDateStringValid = (str) => {
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?Z$/;
       if (!isoRegex.test(str)) return false;
        const date = new Date(str);
        return !isNaN(date.getTime());
    };
 const isStaticForm = formId === staticForm1 || formId === staticForm2 ? true : false;

 let averageScore;
 if(isStaticForm){
  let scores = [];
    const entries = Object.entries(section).sort(([a], [b]) => {
      return parseInt(a.replace("answer", ""), 10) - parseInt(b.replace("answer", ""), 10);
    });
    for (const [key, value] of entries) {
      if (key.startsWith("answer")) {
        if (isNaN(value) || value === null || value === "") {
          break;
        }
        scores.push(Number(value));
      }
    }
    console.log(scores)
    const totalScore = scores.reduce((sum, val) => sum + val, 0);
    averageScore = scores.length > 0 ? totalScore / scores.length : 0;
 }

 return (
    <>
    <TableRow hover selected={selected}>
            {tableHead?.map((header, index) => {
                try {
                    if(isDateStringValid(section[header.name])){
                        return (
                         <TableCell key={index} sx={{whiteSpace: 'nowrap'}}>{fDate(section[header?.name], "dd/MM/yyyy")}</TableCell>
                        )
                    }else {
                        return (
                         <TableCell key={index} sx={{whiteSpace: 'nowrap'}}>{section[header?.name]}</TableCell>
                        )
                    }
                }catch{
                  return (
                     <TableCell key={index} sx={{whiteSpace: 'nowrap'}}>{section[header?.name]}</TableCell>
                  )
                }
                })}
           { isStaticForm && <TableCell  sx={{whiteSpace: 'nowrap'}}>{averageScore?.toFixed(2)}</TableCell>} 
           <TableCell  sx={{whiteSpace: 'nowrap'}}>
                <Label
                    variant="soft"
                    color={
                    (status === 'In-Progress' && 'success') ||
                    (status?.toLowerCase() === 'archived' && 'secondary') ||
                    (status?.toLowerCase() === 'completed' && 'info') ||
                    (status?.toLowerCase() === 'cancelled' && 'error') || 
                    (status?.toLowerCase() === 'draft' && 'warning') ||
                                  'default'
                    }
                    >
                    {status}
                </Label>

           </TableCell>
            <TableCell align="right" sx={{px: 1, whiteSpace: 'nowrap', width: '1px'}}>
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
            </TableCell>
    </TableRow>
    <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{width: 220}}
    >
        <MenuItem onClick={onViewRow}
          hidden={status === 'Cancelled' ? true : false}
        >
            <Iconify icon="ic:round-print" />
            Print
        </MenuItem>

        <MenuItem onClick={() => {
            onEditRow();
            popover.onClose()
        }}
        hidden={status === 'Draft' || status === 'In-Progress' ? false : true}
        >
            <Iconify icon="solar:pen-bold" />
            Update
        </MenuItem>

        <MenuItem onClick={() => {
            confirmArchive.onTrue();
            popover.onClose();
        }}
        hidden={status === 'Completed'  ? false : true}
        >
            <Iconify icon="solar:archive-bold-duotone" />
            Archive
        </MenuItem>

        <MenuItem onClick={() => {
            onComplete();
            popover.onClose();
        }}
        hidden={status === 'Archived' ? false : true}
        >
            <Iconify icon="solar:square-arrow-left-bold-duotone" />
            Revert to Completed
        </MenuItem>


        <MenuItem onClick={() => {
            confirmComplete.onTrue();
            popover.onClose()
        }}
        hidden={status !== 'In-Progress' ? true : false}
        >
            <Iconify icon="solar:check-read-bold-duotone" />
            Complete
        </MenuItem>

      <MenuItem onClick={() => {
            confirmCancelled.onTrue();
            popover.onClose()
        }}
        hidden={status !== 'In-Progress' ? true : false}
        >
            <Iconify icon="solar:close-square-line-duotone" />
            Cancel
        </MenuItem>


        <MenuItem onClick={() => {
            revertInProgress();
            popover.onClose();
        }}
        hidden={status === 'Completed' || status === 'Cancelled' ? false : true}
        >
            <Iconify icon="solar:square-arrow-left-bold-duotone" />
            Revert to In-Progress
        </MenuItem>

        


        <MenuItem onClick={() => {  
            confirm.onTrue();
            popover.onClose();
         }} sx={{ color: 'error.main'}}
         hidden={status === 'In-Progress' || status === 'Completed'  ? true : false}
         >
            <Iconify icon="solar:trash-bin-trash-bold" />
            Delete
        </MenuItem>
            


    </CustomPopover>

    <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Confirm delete? This action cannot be undone.`}
        action={
          <Button variant="contained" color="error" onClick={() => {
            onDeleteRow();
            confirm.onFalse();
          }}>
            Delete
          </Button>
        }
      />

          <ConfirmDialog
        open={confirmArchive.value}
        onClose={confirmArchive.onFalse}
        title="Archive"
        content={`Confirm change to Archive?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onArchive();
            confirmArchive.onFalse();
          }}>
            Archive
          </Button>
        }
      />

        <ConfirmDialog
        open={confirmComplete.value}
        onClose={confirmComplete.onFalse}
        title="Complete"
        content={`Confirm change to Complete?`}
        action={
          <Button variant="contained" color="success" onClick={() => {
            onComplete();
            confirmComplete.onFalse();
          }}>
            Complete
          </Button>
        }
      />

              <ConfirmDialog
        open={confirmCancelled.value}
        onClose={confirmCancelled.onFalse}
        title="Cancel"
        content={`Confirm change to Cancelled?`}
        action={
          <Button variant="contained" color="error" onClick={() => {
            onCancelled();
            confirmCancelled.onFalse();
          }}>
            Cancel
          </Button>
        }
      />

</>
 )

}

AuditingTableRow.propTypes = {
    onEditRow: PropTypes.func,
    onViewRow: PropTypes.func,
    onArchive: PropTypes.func,
    onComplete: PropTypes.func,
    onCancelled: PropTypes.func,
    revertInProgress: PropTypes.func,
  };
  